import React from 'react';
import classes from './Radio.module.css';
import PropTypes from 'prop-types';

export const Radio = ({ variant = 'primary', value, setValue, label, disabled }) => {
  return (
    <div className={`my-2 ${classes.radioWithLabel}`}>
      <input
        type="radio"
        id={`radio${label}`}
        checked={value === label && 'checked'}
        // checked={value === label}
        disabled={disabled}
        onChange={() => {
          if (value == label) {
            setValue(false);
          } else {
            setValue(label);
          }
        }}
        className={variant === 'primary' ? classes.primaryRadioInput : classes.radioInput}
      />
      {label && (
        <label
          htmlFor={`radio${label}`}
          className={variant === 'primary' ? classes.primaryLabel : classes.label}>
          {label}
        </label>
      )}
    </div>
  );
};

Radio.propTypes = {
  value: PropTypes.string,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired
};
Radio.defaultProps = {
  value: false,
  disabled: false,
  label: null
};
